"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M18.742 0c1.1 0 2.003.855 2.08 1.934l.005.149v19.835c0 1.098-.855 2-1.936 2.077l-.148.005H5.255c-1.098 0-2-.855-2.076-1.933l-.006-.149V2.083c0-1.099.855-2.001 1.934-2.078L5.255 0h13.488Zm0 .992H5.255c-.56 0-1.024.426-1.083.972l-.007.119v19.835c0 .56.426 1.024.972 1.084l.118.006h13.488c.561 0 1.026-.426 1.085-.971l.006-.119V2.083c0-.562-.426-1.025-.973-1.085l-.119-.006Zm-3.965 18.843a.496.496 0 0 1 .089.984l-.09.008H9.224a.495.495 0 0 1-.09-.984l.09-.008h5.554Zm1.586-3.174a.496.496 0 0 1 .089.983l-.09.008H7.637a.495.495 0 0 1-.09-.983l.09-.008h8.727ZM11.98 2.385 12 2.38l.018.005a6.425 6.425 0 0 1 4.54 1.883 6.455 6.455 0 0 1 0 9.117 6.43 6.43 0 0 1-4.541 1.885l-.017.003-.018-.003a6.431 6.431 0 0 1-4.541-1.885 6.455 6.455 0 0 1 0-9.117 6.43 6.43 0 0 1 4.54-1.883Zm4.849 8.922h-2.2a8.626 8.626 0 0 1-1.405 2.818 5.392 5.392 0 0 0 2.632-1.441c.343-.344.614-.729.842-1.133l.131-.244Zm-7.461 0H7.17c.252.493.56.965.973 1.377a5.39 5.39 0 0 0 2.631 1.44 8.668 8.668 0 0 1-1.3-2.478l-.105-.34Zm4.225 0h-3.188A7.508 7.508 0 0 0 12 14.07a7.496 7.496 0 0 0 1.475-2.423l.119-.34ZM9.147 7.339H6.779a5.447 5.447 0 0 0-.075 2.68l.075.295h2.368a9.051 9.051 0 0 1-.053-2.608l.053-.367Zm4.698 0h-3.691a8.084 8.084 0 0 0-.06 2.609l.06.366h3.691a8.06 8.06 0 0 0 .06-2.608l-.06-.367Zm3.375 0h-2.367a9.193 9.193 0 0 1 .053 2.608l-.053.367h2.367c.25-.877.274-1.796.075-2.681l-.075-.294Zm-6.441-3.817A5.403 5.403 0 0 0 8.143 4.97a5.1 5.1 0 0 0-.842 1.133l-.131.245h2.199a8.648 8.648 0 0 1 1.41-2.826ZM12 3.584a7.466 7.466 0 0 0-1.475 2.423l-.119.34h3.188A7.532 7.532 0 0 0 12 3.585Zm1.22-.062a8.633 8.633 0 0 1 1.305 2.485l.105.34h2.2a5.386 5.386 0 0 0-.973-1.377 5.41 5.41 0 0 0-2.637-1.448Z",
    clipRule: "evenodd"
  })]
});